import React from 'react';
import {
  useParams,
  useSearchParams,
  Link,
  useNavigate,
} from 'react-router-dom';
import ProDocDisplay from './ProDocDisplay';
import AgentTabs from './AgentTabs';
import { ReactComponent as ShowDocsIcon } from '../../icons/show-docs.svg';
import './conversational-dashboard.scss';

const ProDocView: React.FC = () => {
  const { proDocId } = useParams<{ proDocId: string }>();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  const navigate = useNavigate();

  if (!proDocId) {
    return <div>ProDoc ID not found</div>;
  }

  const handleBack = () => {
    // Navigation will be handled by Link component
  };

  const handleTabClick = (agentId: string) => {
    navigate(`/?agent_id=${agentId}`);
  };

  return (
    <div className='pro-doc-view conversational-dashboard'>
      <div className='pro-docs-wrapper'>
        <div className='pro-doc-breadcrumb'>
          {returnTo ? (
            <Link to={returnTo} className='breadcrumb-link'>
              ← Back to Agent
            </Link>
          ) : (
            <Link to='/docs' className='breadcrumb-link'>
              <ShowDocsIcon /> All my docs
            </Link>
          )}
        </div>
        <div className='pro-docs-content'>
          <ProDocDisplay proDocId={proDocId} onBack={handleBack} />
        </div>
      </div>
    </div>
  );
};

export default ProDocView;
